import { Card, CardBody, Col, Row } from 'reactstrap'
import CountUp from "react-countup";
import ProfitAndLoss from './ProfitAndLoss';
import { H3, Progressbar } from '../../../../AbstractElements';
import { ticketData } from '../../../../Data/Miscellaneous/SupportTicket/SupportTicket';

const TicketList = () => {
  return (
    <Row>
      {ticketData.map((item, index) => (
        <Col xl="4" sm="6" className="box-col-6" key={index}>
          <Card className={`ecommerce-widget bg-light-${item.class}`}>
            <CardBody className="support-ticket-font">
              <Row>
                <Col xs="5">
                  <span>{item.title}</span>
                  <H3 className="total-num counter">
                    <CountUp end={item.num} className="mb-1" />
                  </H3>
                </Col>
                <ProfitAndLoss />
              </Row>
              <div className="progress-showcase mt-3">
                <Progressbar  color={item.class} value={70} style={{ height: '8px' }}></Progressbar>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  )
}

export default TicketList